<template>
	<div class="wastenotificationitemsFormHeader puiformheader">
	</div>
</template>

<script>
import PuiFormHeaderMixin from '@Pui9Mixins/PuiFormHeaderMixin';

export default {
	name: 'wastenotificationitems-form-header',
	mixins: [PuiFormHeaderMixin],
	data() {
		return {
			modelName: 'wastenotificationitems'
		};
	},
	computed: {
	}
}
</script>
